module.exports = __webpack_public_path__ + "src/components/MobileMind/logo.png?3fb4bb39";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileMind/logo.png
// module id = 2811
// module chunks = 1